import { render, staticRenderFns } from "./ExpirationDate.vue?vue&type=template&id=e5d908ac&"
import script from "./ExpirationDate.vue?vue&type=script&lang=ts&"
export * from "./ExpirationDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports